import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';

class AddStaffInAdjust extends Component {
  constructor(props) {
    super(props);
    this.state={
      staff: 0,
      selectStartTime: moment('2018-09-08T10:00'),
      selectEndTime: moment('2018-09-08T10:00'),
      jobType: 0,
      jobTypeList: [
        {
          id: 1,
          title: '正常班',
        },{
          id: 2,
          title: '可支援',
        },
      ]
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handleStaffChange = this.handleStaffChange.bind(this);
  }

  handleSelectStartTimeChange(moment) {
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {
    this.setState({
      selectEndTime: moment
    })
  }

  handleJobTypeChange(e) {
    this.setState({
      jobType: e.target.value
    })
  }

  handleStaffChange(e) {
    this.setState({
      staff: e.target.value
    })
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { editDate, toggleOpen } = this.props;
    const { selectStartTime,  selectEndTime, staff} = this.state;
    if (selectEndTime.diff(selectStartTime) <= 0) {
      swal({
        type: 'error',
        title: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (staff === 0) {
      swal({
        type: 'error',
        title: '請選擇人員',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    let data = {
      userId: staff,
      start: editDate + ' ' + selectStartTime.format('LT'),
      end: editDate + ' ' + selectEndTime.format('LT'),
      resourceId: 6,
      title: ""
    }
    this.props.saveAddStaff(data);
    toggleOpen();
  }

  render() {
    let { isVisible, toggleOpen, editDate } = this.props;
    if (!isVisible) {
      return null;
    }
    return (
      <div className="u-editblock fadeIn" onClick={toggleOpen}>
        <div className="form-block" onClick={(e)=>{e.stopPropagation();}}>
          <div className="u-small-title">新增上班人員</div>
          <form className="u-form">
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">日期： {editDate}</label>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">員工：</label>
                <select value={Number(this.state.staff)} className="u-form__select" 
                  onChange={this.handleStaffChange}
                >
                  <option value="0" disabled>請選擇</option>
                  {
                    this.props.allStaff.map(staff => (
                      <option key={staff.id} value={staff.id}>{ staff.realName }</option>
                    ))
                  }
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：</label>
                <DatePicker
                  id="addStaff_selectStartTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  selected={this.state.selectStartTime}
                  onChange={this.handleSelectStartTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('addStaff_selectStartTime').click();
                    }}
                >
                  {this.state.selectStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至：</label>
                <DatePicker
                  id="addStaff_selectEndTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  selected={this.state.selectEndTime}
                  onChange={this.handleSelectEndTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                 <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('addStaff_selectEndTime').click();
                    }}
                >
                  {this.state.selectEndTime.format('HH:mm')}
                </button>
              </div> 
            </div>
            <div className="u-btn-group right">
              <button className="btn btn-md save" onClick={this.handleSaveWorkTime}>儲存</button>
              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  toggleOpen();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddStaffInAdjust;